import { DescriptionTextType } from "../../types/commonTypes/descriptionTextType";

export const initialDescriptionTextState: DescriptionTextType = {
    descriptionText: ""
}